import React from "react";
import { Routes, Route } from "react-router-dom";

import ProgramListScreen from "./ProgramListScreen";
import ProgramScreen from "./ProgramScreen";
import OnboardingRoutes from "../Onboarding/OnboardingRoutes";

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="" element={<ProgramListScreen />} />
      <Route path="/:support_program_key" element={<ProgramScreen />} />
      <Route
        path="/:support_program_key/onboarding/*"
        element={<OnboardingRoutes />}
      />
    </Routes>
  );
};

export default AppRoutes;
